let modals            = require( './modals' ),
	register_interest = require( './register-interest-forms' );

let vibe_cake_masters_cta_cards = function( $ ) {

	let $cards,
		anim_speed = 400;

	let _init = function() {
		$cards = $( '.cake-masters-component.course-cta-card' );

		if ( $cards.length > 0 ) {
			_setup_cards();
		}
	};

	let _setup_cards = function() {
		$cards.not( '.initialised' ).each( ( index, item ) => {
			let $card = $( item );

			$card.find( 'a.toggle-module-lessons' ).on( 'click', function( e ) {
				e.preventDefault();
				_toggle_panel( $( this ).closest( '.module' ) );
			} );

			if ( $card.find( '.user-register-interest' ).length > 0 ) {
				$card.find( '.user-register-interest' ).on( 'click', function( e ) {
					e.preventDefault();

					$card.loading();

					register_interest.register_interest( 'self', $( this ).data( 'course-id' ), '', '', $card );
				} );
			}

			if ( $card.find( '.user-unregister-interest' ).length > 0 ) {
				$card.find( '.user-unregister-interest' ).on( 'click', function( e ) {
					e.preventDefault();

					$card.loading();

					register_interest.unregister_interest( 'self', $( this ).data( 'course-id' ), '', $card );
				} );
			}

			$card.on( 'masters-registered-interest_success masters-unregistered-interest_success', ( e, response ) => {
				update_card( $card.data( 'course-id' ) );
			} );

			$card.addClass( 'initialised' );
		} )
	};

	let _toggle_panel = function ( $panel ) {
		if ( $panel.hasClass( 'animating' ) ) {
			return;
		}

		$panel.addClass( 'animating' );

		if ( $panel.hasClass( 'closed' ) ) {
			_open_panel( $panel )
		} else {
			_close_panel( $panel );
		}

		setTimeout( () => {
			$panel.removeClass( 'animating' );
		}, anim_speed )
	};

	let _open_panel = function( $panel ) {
		$panel.find( '.toggle-panel' ).slideDown( anim_speed );

		setTimeout( () => {
			$panel.removeClass( 'closed' );
			$panel.addClass( 'open' );
		}, anim_speed );
	};

	let _close_panel = function( $panel ) {
		$panel.find( '.toggle-panel' ).slideUp( anim_speed );

		setTimeout( () => {
			$panel.removeClass( 'open' );
			$panel.addClass( 'closed' );
		}, anim_speed );
	};

	let update_card = function( course ) {
		let $cta = $( '#masters-course-cta-card-' + course );

		if ( $cta.length > 0 ) {
			$cta.loading();

			let data = {
				nonce: VibeCakeMastersScriptData.vibe_cake_masters_cta_cards_get_html_nonce,
				action: 'vibe_cake_masters_course_cta_cards_get_html',
				course: course,
			};

			$.post( VibeCakeMastersScriptData.ajaxurl, data, ( response ) => {
				if ( response.success ) {
					$cta.replaceWith( response.html );
					modals.init();
					_init();
				} else {
					window.location.reload();
				}
			} );
		}
	};

	$( document ).ready( _init );

	return {
		update_card: update_card,
	}

} ( jQuery );

module.exports = vibe_cake_masters_cta_cards;